module.exports = __webpack_public_path__ + "img/ic-credit-card.5d28bd67.svg";